"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttendeeDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const attendee_json_1 = require("./attendee-json");
exports.AttendeeDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Attendee', attendee_json_1.AttendeeJsonMapper);
